import {cs}          from "../../react/chain-services";
import {AlertModal} from "../../ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {isDevXd} from "@Common/ui-components/debug/is-dev";

export const NotifyFailover = ({ccHostResponse, next}) => cs(
    ["alertModal", ({}, next) => AlertModal({next})],
    ({alertModal}) => next(async (internetIsConnected, failoverServerIsAvailable, changesSaved) => {

        // remove the CC host - this will let other components know to suppress functionality due to a known connectivity issue
        ccHostResponse.onChange({...ccHostResponse.value, ccHost: null});

        // display the alert and refresh page after user accepts
        await alertModal.show({
            actionName: "reload",
            message: "Network Error",
            description: [
                // build the description based from failover availability and save status
                "There was an error communicating with the server.",
                ...!internetIsConnected ? [
                    "Please check your connection and reload to continue."
                ] : !failoverServerIsAvailable ? [
                    "We have been notified of the issue. Please try again later."
                ] : [
                    "You must reload to continue.",
                    changesSaved ? (
                        "All changes have been saved."
                    ) : (
                        "Any changes since your last save will be lost."
                    )
                ],
            ].join(" "),
        });
        if (isDevXd()) {
            alert("Reloading page because cc integration error");
        }

        location.reload();

    }),
);
